// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"9306893f","57":"9b808c92","74":"7f30855e","112":"ecb54b29","530":"2981243a","979":"908d8893"}[chunkId] + ".chunk.css";
};